import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {UrlQueryService} from '../../../../common/url-query/url-query.service';

@Injectable({
  providedIn: 'root'
})
export class CallsQuotaApiService {

  constructor(private http: HttpClient) {}

  private readonly callsQuotaUrl: string = 'calls/quota';
  private readonly callsQuotaConfigurationUrl: string = 'configuration/quota';

  public getCallsQuotas(params: object = {}): Observable<any> {
    const generatedCallsQuotasUrl = UrlQueryService.addQueryParameters(this.callsQuotaUrl, params);

    return this.http.get(generatedCallsQuotasUrl);
  }

  public getCallsQuota(callsQuotaId): Observable<any> {
    return this.http.get(`${this.callsQuotaUrl}/${callsQuotaId}`);
  }

  public addCallsQuota(callsQuota): Observable<any> {
    return this.http.post(this.callsQuotaUrl, callsQuota);
  }

  public editCallsQuota(callsQuota, callsQuotaId): Observable<any> {
    return this.http.put(`${this.callsQuotaUrl}/${callsQuotaId}`, callsQuota);
  }

  public deleteCallsQuota(callsQuotaId) {
    return this.http.delete(`${this.callsQuotaUrl}/${callsQuotaId}`);
  }

  public getCallsQuotasConfiguration(): Observable<any> {
    return this.http.get(this.callsQuotaConfigurationUrl);
  }

  public editCallsQuotasConfiguration(callsQuotasConfiguration): Observable<any> {
    return this.http.put(this.callsQuotaConfigurationUrl, callsQuotasConfiguration);
  }
}

